import axios from 'axios';
import { auth } from '@/firebase.config';
import { dreamMeetUrl } from '@/domain/dreamMeet';

// Creates a dream meet meeting as the signed-in teacher. dream-meet checks the
// teacher role itself and must list this site in MEETING_CREATE_ORIGINS.
export async function createDreamMeeting(origin) {
    if (!auth.currentUser) throw new Error('Sign in to create a meeting.');
    const token = await auth.currentUser.getIdToken();
    let response;
    try {
        response = await axios.post(`${origin}/api/meetings`, {}, {
            headers: { Authorization: `Bearer ${token}` }, timeout: 15000,
        });
    } catch (error) {
        const message = error?.response?.data?.error;
        throw new Error(typeof message === 'string' && message ? message : 'Could not reach dream meet. Check your connection and try again.');
    }
    const url = dreamMeetUrl(origin, response.data?.roomId);
    if (!url) throw new Error('dream meet returned an invalid meeting code. Please try again.');
    return url;
}
